import React from 'react';

import { Box, Typography } from '@mui/material';

import { palette } from 'themeV5/palette';

import logoAlia from 'assets/icons/logo_esferas3.png';

import { publicLayoutHorizontalGutter } from '../styles';

const PublicHeader = () => {
  return (
    <Box
      component="header"
      sx={{
        width: '100%',
        maxWidth: '100%',
        flexShrink: 0,
        boxSizing: 'border-box',
        minHeight: { xs: 56, sm: 72 },
        px: publicLayoutHorizontalGutter,
        py: { xs: 1, sm: 1.25 },
        borderBottom: '1px solid rgba(244, 242, 249, 0.12)',
        backgroundColor: palette.dark.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        columnGap: 2,
      }}
    >
      <Typography
        component="p"
        variant="h5"
        sx={{
          m: 0,
          fontWeight: 800,
          fontSize: { xs: '1.35rem', sm: '1.5rem', md: '1.625rem' },
          lineHeight: 1.15,
          letterSpacing: '-0.03em',
          color: palette.gray[1200],
        }}
      >
        Portex
      </Typography>

      <Box
        component="img"
        src={logoAlia}
        alt="Portex logo"
        sx={{
          width: { xs: 36, sm: 42 },
          height: { xs: 36, sm: 42 },
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default PublicHeader;
